import { Chips } from "../mobile/primitives";

/**
 * SAYFA SEKMELERİ — TEK STANDART. Yeni bir sayfaya sekme eklerken kendi tasarımını YAZMA, bunu kullan.
 * - Masaüstü: alt-çizgili şerit (referans: Inventory / Üretim / QC / Tüketim) — `.pg-tabs` / `.pg-tab` (blocks.css, global).
 * - Mobil (`mobile`): yatay kaydırmalı `.m-chip` rozetleri (referans: Inventory mobil) — mevcut `Chips` primitifi.
 */
export function PageTabs<T extends string>({
  tabs, active, onChange, mobile,
}: {
  tabs: ReadonlyArray<{ key: T; label: string }>;
  active: T;
  onChange: (key: T) => void;
  mobile?: boolean;
}) {
  if (mobile) {
    return (
      <Chips>
        {tabs.map((t) => (
          <button key={t.key} type="button" className={`m-chip ${active === t.key ? "act" : ""}`} onClick={() => onChange(t.key)}>
            {t.label}
          </button>
        ))}
      </Chips>
    );
  }
  return (
    <div className="pg-tabs" role="tablist">
      {tabs.map((t) => (
        <button key={t.key} type="button" role="tab" aria-selected={active === t.key}
          className={`pg-tab ${active === t.key ? "act" : ""}`} onClick={() => onChange(t.key)}>
          {t.label}
        </button>
      ))}
    </div>
  );
}
